import { listRasterFontsForSelectAPI } from '@/service';

const layoutEditorLayoutElementBaseQuery = 'layoutEditorLayoutElement';
export const layoutEditorLayoutElementQuery = [layoutEditorLayoutElementBaseQuery];

export const layoutEditorLayoutElementQueryFunction = () =>
  Promise.all([listRasterFontsForSelectAPI()]);
